import { gql } from '@apollo/client';
export const CLIENT_PROGRAM_LEVELS = gql `
  query CLIENT_PROGRAM_LEVELS($spec: ClientProgramLevelSpec!) {
    clientProgramLevels(spec: $spec) {
      total
      page
      pageSize
      items {
        id
        programLevelId
        isActive
        type
        createdAt
        updatedAt
        programLevel {
          id
          name
          isActive
          content {
            id
            clientId
            contentType
            code
            name
          }
          countries {
            id
            name
            code
          }
        }
      }
    }
  }
`;
export const SAVE_CLIENT_PROGRAM_LEVEL = gql `
  mutation SAVE_CLIENT_PROGRAM_LEVEL($input: ClientProgramLevelInput!) {
    saveClientProgramLevel(input: $input) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
export const UPDATE_CLIENT_PROGRAM_LEVELS = gql `
  mutation UPDATE_CLIENT_PROGRAM_LEVELS(
    $input: BulkUpdateClientProgramLevelInput!
    $spec: BulkUpdateClientProgramLevelSpec!
  ) {
    updateClientProgramLevels(input: $input, spec: $spec) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
